import React from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { GET } from '../../utils/HttpClient';
import { FETCH_DATA_LIST } from '../../constance/dataTypes';
import * as _ from 'lodash';
import { Card, Spin, Alert, Empty, Form, Input, Space, List } from 'antd';
import { useDebouncedCallback } from 'use-debounce';

const ItemList = ({ data, content }) => {

  return (
    data.results.map(item => (
      <div>
        <Card
          onClick={content.onClick ? () => content.onClick(item) : undefined}
          title={content.header ? (
            <div style={{ textAlign: 'left' }}>
              <Space>
                {content.header?.icon}
                {content.header?.detail?.(item)}
              </Space>
            </div>) : null
          }
          style={{ marginBottom: '16px', cursor: content.onClick ? 'pointer' : 'default' }}
        >
          <List>
            {content.descriptions.map(description => {
              return (
                <List.Item
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: 'none',

                  }}>
                  <Space>
                    {description.icon}
                    <span>{description.header(item)}</span>
                  </Space>
                  <div style={{ textAlign: 'right' }}>
                    {description.detail(item)}
                  </div>

                </List.Item>

              )
            })
            }
          </List>

        </Card>
      </div>

    ))
  )
}

const MobileList = React.forwardRef((props, ref) => {

  const {
    fetchUrl,
    content,

    // filter props
    showFilterHeader,
    extraFilter,
    extraFilterParams,
  } = props;

  const { t } = useTranslation();
  const [data, setData] = React.useState(FETCH_DATA_LIST);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [date, setDate] = React.useState(null);

  // filter
  const [searchValue, setSearchValue] = React.useState(null);

  const refetch = async (params) => {
    setIsLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(fetchUrl, params);
      setData(response.data);
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  }

  const handleSearch = useDebouncedCallback((value) => {
    refetch({ page: 1, page_size: 10, search: value, date: date, ...extraFilterParams });
  }, 500);

  React.useEffect(() => {
    refetch({ page: 1, page_size: 10, ...extraFilterParams });
  }, [extraFilterParams]);

  const [form] = Form.useForm();

  const renderActionHeader = () => {
    if (extraFilter || showFilterHeader) {
      return (
        <Form form={form}>
          {extraFilter}
          {showFilterHeader &&

            <Form.Item label={t('search')} name={"search"}>
              <Input
                placeholder={`${t('search')}...`}
                allowClear
                onChange={(e) => {
                  setSearchValue(e.target.value)
                  handleSearch(e.target.value)
                }}

              />
            </Form.Item>

          }
        </Form>
      )
    }
    return null;
  }

  return (
    <>
      <Spin spinning={isLoading} fullscreen size='large' />
      {
        errorMessages &&
        <Alert
          message={t('error')}
          description={errorMessages}
          type='error'
        />
      }
      {renderActionHeader()}

      {
        !isLoading && !data.total &&
        <Empty />
      }
      <ItemList
        data={data}
        content={content}
      />
    </>
  );
});

MobileList.defaultProps = {
  fetchUrl: '',
  showFilterHeader: false,
  extraFilter: null,
  extraFilterParams: {},
}

MobileList.propTypes = {
  fetchUrl: propTypes.string,
  showFilterHeader: propTypes.bool,
  extraFilter: propTypes.object,
  extraFilterParams: propTypes.object,
}

export default React.memo(MobileList);